// Tab-scoped cache for the Mux asset list, shared between MuxStreamManager
// and MuxStreamEditor. First load populates it; sibling module reads instantly
// from sessionStorage. Mutations (delete, edit, ingest, etc.) call invalidate().

const KEY = 'mux:assets:v1';
const TTL_MS = 60_000;

export function readCache() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const { ts, assets } = JSON.parse(raw);
    if (Date.now() - ts > TTL_MS) return null;
    return assets;
  } catch {
    return null;
  }
}

export function writeCache(assets) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), assets }));
  } catch {
    // QuotaExceeded — fine, cache just doesn't persist
  }
}

export function invalidate() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
